import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { isManager } from '../lib/auth';
import ManagerDashboard from './ManagerDashboard';
import StaffDashboard from './StaffDashboard';

const Dashboard = () => {
  return isManager() ? <ManagerDashboard /> : <StaffDashboard />;
};

export default Dashboard;
